module.exports = __webpack_public_path__ + "static/img/21.7eaace9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/1/eng/21.png
// module id = ViZF
// module chunks = 0